/**
 * Free Shipping
 * 
 * @module free-shipping
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'free-shipping';

if (!customElements.get(customElements.component)) {

    class freeShipping extends HTMLElement {

        constructor() {

            super();

            if(window.theme.free_shipping && window.theme.free_shipping.goal) {
                this.render();

                this.getCart().then(cart => {
                    this.updateFreeShippingProgress(cart.total_price);
                });

                this.initEvents();
            }
        }

        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            window.addEventListener('addtocart', event => {
                this.getCart().then(cart => {
                    this.updateFreeShippingProgress(cart.total_price);
                });
            });

            window.addEventListener('update', event => {
                this.updateFreeShippingProgress(event.detail.cart.total_price);
            });

            window.addEventListener('remove', event => {
                this.updateFreeShippingProgress(event.detail.cart.total_price);
            });
        }

        /**
         * Reload component
         * 
         * @returns {undefined}
         */
        getCart() {

            return new Promise((resolve, reject) => {

                theme.cart.get().then(data => { 
                    resolve(data);
                });
            });
        }

        /**
         * Render component in the DOM
         * 
         * @returns {undefined}
         */
        render() {
            
            let html = '';

            html = html.replace('{{ shipping_goal }}', window.theme.free_shipping.goal);
            html = html.replace('{{ shipping_goal_price }}', window.theme.money.format(window.theme.free_shipping.goal));

            this.innerHTML = html;

            this.dataset.ready =  true;
        }

        /**
         * Update free shipping progress
         * 
         * @param {number} total_price Cart total price.
         * @returns {undefined}
        */
        updateFreeShippingProgress(total_price) {

            let shippingBar = this.querySelector("[data-shipping-bar]");

            if(shippingBar) {

                let shippingValue = shippingBar.dataset.shippingBar;
                shippingValue = parseInt(shippingValue);
                total_price = total_price / 100;

                if(shippingValue > total_price) {
                    let percentage = (total_price * 100) / shippingValue;
                    percentage = Math.round(percentage);
                    percentage = percentage + "%";
                    this.querySelector("[data-bar]").style.width = percentage;

                    let calc = (shippingValue - total_price) * 100;
                    this.querySelector("[data-shipping-text]").innerHTML = `<span data-shipping-text>Order ${window.theme.money.format(calc)} more to get`;
                }
                else {
                    this.querySelector("[data-bar]").style.width = '100%';
                    this.querySelector("[data-shipping-text]").innerHTML = "Congratulations you got";
                }
            }
        }
    

    }

    customElements.define(customElements.component, freeShipping);
}